import { mapHeatmapChart, CATEGORIES } from '../../configuration/constants'
import { throttle } from '../../utils'

export default {

  // 组件名称
  name: mapHeatmapChart,

  // 前面板html模板
  viewTemplate() {
    return `
      <div data-gjs-type="${mapHeatmapChart}" class="${mapHeatmapChart}"></div>
    `
  },
  // 前面板html样式
  viewStyle() {
    return `
      <style>
        .${mapHeatmapChart} {
          position: absolute;
          border-radius: 5px;
          border-style: solid;
          border-width: 1px;
          border-color: transparent;
          padding: 10px;
          width: 600px;
          height: 400px;
        }
      </style>
    `
  },

  // 编辑器右侧块管理器中显示属性配置
  blockOptions() {
    return {
      label: `
        <svg class="gjs-block-svg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path class="gjs-block-svg-path" d="M399.87712 250.73152c10.5984 0 20.16256 2.65216 29.77792 8.42752 37.73952 21.84192 76.46208 45.83936 117.4016 71.22944 57.7024 35.7888 117.4016 72.75008 181.22752 107.77088 34.39104 17.58208 58.112 58.32192 60.41088 103.79776 0.97792 19.3792-1.25952 67.3024-42.4192 94.01856-104.4224 64.88064-219.648 105.75872-327.08096 141.47072-14.08 4.04992-29.00992 6.07232-44.35968 6.07232-45.3376 0-89.97888-17.8688-113.69984-45.55776-12.55936-14.57152-17.64864-30.2592-14.91968-47.6416l21.82144-175.49824 18.63168-149.4784c8.71424-58.88512 63.75424-114.6112 113.20832-114.6112m0-40.81152c-69.888 0-141.952 71.30112-153.51808 149.4784-13.5424 108.68224-27.06944 217.29792-40.6016 325.98016C193.75616 763.49952 281.856 824.32 374.8352 824.32c18.56 0 37.31968-2.44224 55.52128-7.59808 119.63904-39.76192 232.07936-80.64 337.408-146.14016 95.43168-61.85984 74.07104-220.00128-20.93056-268.6976-106.01984-58.24-204.99968-124.91776-296.80128-178.00192A95.93856 95.93856 0 0 0 399.87712 209.92z" p-id="6586"></path><path d="M394.78272 332.84096l0.62976 0.19968c43.24864 21.98016 89.55904 51.00032 138.53184 81.76128 50.5088 31.60064 102.6816 64.30208 158.55104 93.88032 11.01824 5.71904 13.33248 18.00192 13.74208 23.10144 0.62976 6.20032 0.2816 17.5616-8.43776 23.70048-86.42048 60.27776-183.10144 93.68064-285.50144 129.11104l-41.71776 14.53056a40.41216 40.41216 0 0 1-13.59872 2.29888c-1.32096 0-2.58048-0.08192-3.33824-0.13824-15.42144-1.54112-24.84224-8.59136-25.73824-12.01152l21.83168-179.61984 17.64864-145.99168c2.0224-15.62112 18.688-29.50144 26.72128-30.76096l0.67584-0.06144m0-40.73984c-2.37056 0-4.74112 0.19968-7.11168 0.55808-25.8816 4.10112-56.43776 32.13824-60.69248 65.83808-13.18912 108.60032-26.30144 217.22112-39.48032 325.89824-4.33152 33.46944 28.88192 54.20032 62.21824 57.48224 2.44224 0.19968 4.87936 0.2816 7.33184 0.2816 9.27232 0 18.41152-1.54112 27.26912-4.68992 121.78944-42.69056 234.09152-76.87168 336.91136-148.57216 26.85952-18.97984 26.7776-49.4592 25.68192-61.04064-1.12128-11.91936-7.12192-40.58112-35.51232-55.3216-108.61056-57.53856-207.72864-130.16064-297.3696-175.77984a41.8816 41.8816 0 0 0-19.24608-4.65408z" p-id="6587"></path><path d="M459.23328 448.13824c17.64864 9.75872 36.41856 21.53984 56.01792 33.89952 23.5008 14.72 47.70816 29.92128 73.93792 44.29824-39.56224 25.46176-82.80064 40.43776-132.32128 57.6l-15.0016 4.7616 7.45984-61.88032 9.9072-78.67904m-5.85728-46.59712c-15.20128 0-31.52896 15.75936-33.8176 32.9216-6.84032 56.58112-13.68064 113.152-20.5824 169.7792-2.24256 16.39936 15.05792 28.46208 34.18112 28.46208 4.59776 0 9.28256-0.70144 13.88032-2.16064 63.5392-22.37952 121.99936-40.0384 175.49824-77.50144 19.7376-14.14144 15.8976-47.27808-4.87936-57.75872-56.64256-29.92128-108.32896-67.9424-154.9312-91.44832a19.58912 19.58912 0 0 0-9.34912-2.29376z"></path>
        </svg>
        <div class="gjs-block-label">热力图地图坐标系</div>
      `,
    };
  },

  // 后面板显示属性配置
  spOptions() {
    return {
      label: '热力图地图',
      icon: 'globe',
      // docUrl: 'https://www.yuque.com/docs/share/062e7a46-b543-470c-bbcc-2f4e0466de79#',
      author: '宗介',
      email: 'zongjie.wxt@xuelangyun.com',
      inPorts: [
        {
          uuid: 'in1',
          subType: 'json',
          description: {
            zh_CN: '输入1'
          }
        }, 
        // {
        //   uuid: 'in2',
        //   subType: 'json',
        //   description: {
        //     zh_CN: '输入2'
        //   }
        // }, {
        //   uuid: 'in3',
        //   subType: 'json',
        //   description: {
        //     zh_CN: '输入3'
        //   }
        // }
      ]
    }
  },

  // 组件属性
  componentOptions() {
    return {
      resizable: true,
      dmode: 'absolute',
      childrenSelectable: false,
      highlightable: false,
      droppable: false,
      traits: [
        {
          name: 'centerPos',
          label: '视觉中心点(经、纬度)',
          changeProp: 1
        },
        {
          name: 'zoom',
          label: '地图缩放',
          changeProp: 1,
          type: 'number',
          min: 3,
          max: 18,
        },
        {
          name: 'pitch',
          label: '地图倾角',
          changeProp: 1,
          type: 'number',
          max: 83,
          min: 1
        },
        {
          name: 'rotation',
          label: '地图旋转角度',
          changeProp: 1,
          type: 'number'
        },
        {
          name: 'isFitView',
          label: '自动适配视野范围',
          changeProp: 1,
          type: 'checkbox'
        },
        {
          name: 'colorMap',
          label: '颜色映射',
          changeProp: 1
        },
        {
          name: 'viewMode',
          label: '视图模式',
          changeProp: 1,
          type: 'select',
          options: [{ id: '2D', name: '2D' }, { id: '3D', name: '3D' }]
        },
        {
          name: 'dataType',
          label: '数据类型',
          changeProp: 1,
          type: 'select',
          options: [{ id: 'null', name: '高德坐标' },{ id: 'gps', name: 'GPS原始坐标' }, { id: 'baidu', name: '百度经纬度' }]
        },
        {
          name: 'csv',
          label: '示例数据',
          changeProp: 1,
          type: 'csvDownload',
          preFileName: '地图热力图',
          datas: [
            [120.331245217235 ,31.453661955110 ,0 ,0], 
            [120.331245217235 ,31.535059433220 ,0 ,0], 
            [120.345654194394 ,31.535059433220 ,0 ,0], 
            [120.389781686944 ,31.453661955110 ,0 ,0], 
          ]
        },
        {
          name: 'defaultData',
          changeProp: 1,
          type: 'hide'
        },
        {
          name: 'defaultDataSetting',
          changeProp: 1,
          type: 'hide'
        }
      ],
      'defaultData':JSON.stringify([
        [120.331245217235 ,31.453661955110 ,0 ,0], 
        [120.331245217235 ,31.535059433220 ,0 ,0], 
        [120.345654194394 ,31.535059433220 ,0 ,0], 
        [120.389781686944 ,31.453661955110 ,0 ,0],
      ]).replace(/\"/g, "\\\""),
      'defaultDataConfig': JSON.stringify({
        dataIncludeHeader: false,
        addS: false,
        tableColumns: [
          {title: "经度", type: "number"},
          {title: "纬度", type: "number"},
          {title: "区域编号", type: "number"},
          {title: "区域颜色", type: "number"}
        ]
      }).replace(/\"/g, "\\\""),
      'centerPos': '120.332552, 31.45982',
      'colorMap': '0: #F5DEB3, 1:#FFA07A, 2:#FF7F50, 3: #FF6A6A, 4: #FF3030, 5: #FF0000, 6:#EE0000, 7:#CD0000, 8:#8B0000, 9:#8B2323',
      'viewMode': '3D',
      'pitch': 50,
      'rotation': 0,
      'isFitView': true,
      'zoom': 10,
      'dataType': 'gps',
    }
  },

  onModelScript() {
    let centerPos = '{[ centerPos ]}'.toString();
    const colorMap = '{[ colorMap ]}'.toString();
    const viewMode = '{[ viewMode ]}';
    const isFitView = Boolean('{[ isFitView ]}');
    const pitch = Boolean('{[ pitch ]}') ? Number('{[ pitch ]}') : 50; 
    const rotation = Boolean('{[ rotation ]}') ? Number('{[ rotation ]}') : 30; 
    const zoom = Boolean('{[ zoom ]}') ? Number('{[ zoom ]}') : 30;
    const dataType = '{[ dataType ]}'.toString();
    const defaultData = JSON.parse('{[ defaultData ]}'.replace(/\\\"/g, "\""));

    if (centerPos.indexOf(',') > -1) {
      centerPos = centerPos.split(',').map(item => {
        const itemTrim = item.trim();
        const itemNum = Number(itemTrim);
        if(isNaN(itemNum)) {
          return 0
        } else {
          return itemNum;
        }
      })
    } else {
      centerPos = [120.332552, 31.45982];
    }

    let _colorMap = {};
    let defaultColor = '#FF0000';
    if (colorMap.indexOf(':') > 0) {
      let _colorArr;
      if (colorMap.indexOf(',') > 0) {
        _colorArr = colorMap.split(',');
      } else {
        _colorArr = [colorMap];
      }
      _colorArr.forEach(function (item) {
        if (item.indexOf(':') > 0) {
          const _item = item.trim().split(':').map(v => v.trim());
          _colorMap[_item[0].toString().toLocaleLowerCase()] = _item[1];
        }
      });
    }

    var dataMap = {
      lng: 0,
      lat: 1,
      no: 2,
      level: 3
    };

    var ak = '74433b3634087a24acd80fb30a682da5';
    var url = `https://webapi.amap.com/maps?v=1.4.15&key=${ak}&callback=onLoad`;


    var jsapi = document.createElement('script');
    jsapi.charset = 'utf-8';
    jsapi.src = url;
    document.head.appendChild(jsapi);
    window.onLoad  = function(){
      initMap(defaultData);
    }

    var addHeatmapLayer = function(dataList) {
      if (dataList.length > 0) {
        let polygonNo = dataList[0][dataMap.no];
        let polygonLevel = dataList[0][dataMap.level];
        let lngLatList = [];
        dataList.forEach(data => {
          if(data[dataMap.no] === polygonNo) {
            lngLatList.push([data[dataMap.lng],data[dataMap.lat]])
          } else {
            addPolygonLayer(lngLatList, polygonLevel);
            polygonNo = data[dataMap.no];
            polygonLevel = data[dataMap.level];
            lngLatList = [];
          }
        })
        addPolygonLayer(lngLatList, polygonLevel);
      }
    }

    var addPolygonLayer = function (path, val) {
      const pathNew = path.map(pathEL => new AMap.LngLat(pathEL[0],pathEL[1]));
      if (dataType === "null") {
        addPolygon(pathNew, val);
      } else {
        AMap.convertFrom(pathNew, dataType, function (status, result) { // 坐标系转换
          if (result.info === 'ok') {
            var lnglats = result.locations;
            addPolygon(lnglats, val)
          }
        });
      }
    };

    var addPolygon = function (path, val) {
      var color = _colorMap[val];
      if (color === undefined) color = defaultColor;
      var polygon = new AMap.Polygon({
          path: path,  
          fillColor: color, // 多边形填充颜色
          strokeWeight: 0, // 轮廓线宽度
          strokeOpacity: 0,
      });

      map.add(polygon);
      // 自适应地图大小
      if(isFitView) {
        map.setFitView();
      }
    }
    
    const self = this;
    var map;
    
    var initMap = function (data) {
      map = new AMap.Map(self,{
        features: ['bg', 'road', 'building'], // 显示部分底图元素 bg-> 区域面, building=> 建筑物, road => 道路及道路标注 point => 兴趣点
        // mapStyle: 'amap://styles/1de318cbb8d12c02303a22c550b9ccc9',
        pitch: pitch, // 地图俯仰角度，有效范围 0 度- 83 度
        rotation: rotation,
        zoom: zoom,
        center: centerPos,//中心点坐标
        viewMode: viewMode, //使用3D视图
        resizeEnable: true,
      });
      map.plugin(["AMap.PolyEditor", "AMap.convertFrom"],function(){
        addHeatmapLayer(data);
      });
    }


  
    // 有 dashboardHost 说明是运行模式
    if (window.spSocket) {
      var eventName = `call-` + self.getAttribute('id');
      window.spSocket.subscribe({
        eventName: eventName,
        callback: function (_data) {
          let _in1Str = _data.data.in1;
          if (_in1Str) {
            const source = JSON.parse(_in1Str);
            initMap(source);
          }
        }
      });
    }
  },

  onViewInit() {
    this.updateScript();
    const evn = `
    change:defaultData
    change:centerPos
    change:colorMap
    change:viewMode
    change:isFitView
    change:pitch
    change:rotation
    change:zoom
    change:dataType
    `;
    this.listenTo(this.model, evn, this.updateScript);
    this.listenTo(this.model, evn, this.em.handleUpdates.bind(this.em));
    this.listenTo(this.em, 'update:component:style:height update:component:style:width', throttle.bind(this, this.updateScript.bind(this)));
  }
}
